import {
	SET_CART_ATTEMPTS_COUNT,
} from '../actions/setUserSession'

const initialState = {
	cartAttemptsCount: 1
}

export default function setUserSessionReducers(state = initialState, action) {
	switch(action.type) {
		case SET_CART_ATTEMPTS_COUNT:
			return {
				...state,
				cartAttemptsCount: action.payload
			}
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/setUserSessionReducers.js